import HandyCollapse from "handy-collapse"

export default function initAccordion() {
  const isAccordion = document.getElementsByClassName("accordion")

  if (isAccordion.length > 0) {
    const myAccordion = new HandyCollapse()
    myAccordion.close()
  }
}
